module.exports = __webpack_public_path__ + "static/media/448.6d8381c9.png";